import * as React from "react";

import { AgentThread } from "./AgentThread";
import { AgentThreadHistoryView } from "./AgentThreadHistoryView/AgentThreadHistoryView";
import styles from "./AgentThreadSidebarMainContent.module.css";
import { useAIAgentThread } from "./AIAgentThreadContext";
import { EarlyAccessBanner } from "./EarlyAccessBanner";

/**
 * Shared main content component used by both the sidebar and fullscreen modal.
 * Handles the conditional rendering of thread views vs history.
 * AgentThread component handles all data fetching and mutations.
 */
export const AgentThreadSidebarMainContent: React.FC = () => {
  const { showHistory } = useAIAgentThread();

  return (
    <div className={styles.mainContainer}>
      <EarlyAccessBanner />
      {showHistory ? <AgentThreadHistoryView /> : <AgentThread />}
    </div>
  );
};
